// extracted by mini-css-extract-plugin
export default {"memberTenantHoldings":"memberTenantHoldings---sN0L8"};